import { Link } from "react-router-dom";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#F2F6F4] text-[#0A1410]" style={{ fontFamily: "Roboto, sans-serif" }}>
      <header className="border-b border-[#D8E2DC] bg-white">
        <div className="mx-auto flex h-14 max-w-2xl items-center gap-3 px-4">
          <img src="/Dprologo.png" alt="DeportivosPro" className="h-8 w-8 rounded-full" />
          <p className="font-extrabold text-[#0D5C47]">DeportivosPro</p>
          <Link to="/prediccion-zone/join" className="ml-auto text-sm font-semibold text-[#0D5C47]">
            Volver
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-8">
        <h1 className="text-3xl font-extrabold">{title}</h1>
        <p className="mt-2 text-sm text-[#5A6B62]">Vigente desde el 14 de octubre de 2026. Colombia.</p>
        <div className="mt-6 space-y-6 text-sm leading-6">{children}</div>
      </main>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-extrabold">{title}</h2>
      <div className="mt-2 space-y-2 text-[#0A1410]">{children}</div>
    </section>
  );
}

export function TermsPage() {
  return (
    <Shell title="Términos y condiciones">
      <Block title="Qué es DeportivosPro">
        <p>
          DeportivosPro es un servicio informativo de consejos y análisis deportivos. Muestra partidos, un consejo del encuentro y un porcentaje de confianza para que la persona llegue al partido con más contexto.
        </p>
        <p>
          No es una casa de apuestas. Dentro de la aplicación no se compran productos, no se cargan saldos y no se gestionan pagos.
        </p>
      </Block>
      <Block title="La cuenta">
        <p>
          Para crear una cuenta pedimos nombre, correo electrónico y una contraseña. Con la cuenta puedes marcar me gusta, comentar, guardar consejos y registrar tickets de soporte.
        </p>
        <p>La persona es responsable de mantener su contraseña en privado y de que los datos que escribe sean suyos.</p>
      </Block>
      <Block title="El contenido">
        <p>
          Los consejos son opiniones informativas. No prometen un resultado. El porcentaje de confianza es una referencia del análisis, no una garantía.
        </p>
        <p>
          Los comentarios que publicas se muestran con tu nombre a otras personas que ven ese consejo. No publiques datos de otras personas ni contenido que no te pertenezca.
        </p>
      </Block>
      <Block title="El grupo">
        <p>
          Quien quiera más detalle puede escribir por WhatsApp al +57 333 277 1764. Esa conversación ocurre fuera de la aplicación, en WhatsApp.
        </p>
      </Block>
      <Block title="Edad">
        <p>El servicio está dirigido a personas mayores de 18 años.</p>
      </Block>
      <Block title="Cierre de la cuenta">
        <p>
          Puedes pedir que eliminemos tu cuenta y los datos asociados escribiendo un ticket en Ayuda o al WhatsApp de soporte. Dejaremos de usarlos salvo que una norma nos obligue a conservarlos.
        </p>
      </Block>
    </Shell>
  );
}

export function PrivacyPage() {
  return (
    <Shell title="Política de privacidad">
      <Block title="Quién trata los datos">
        <p>
          DeportivosPro trata los datos de la cuenta para prestar el servicio de consejos y análisis deportivos. El contacto de soporte es el WhatsApp +57 333 277 1764 y el centro de tickets dentro de la aplicación.
        </p>
      </Block>
      <Block title="Qué datos guardamos">
        <p>Nombre, correo electrónico y contraseña de la cuenta. La contraseña se guarda de forma protegida por el sistema de acceso y no la vemos en texto plano.</p>
        <p>Me gusta, consejos guardados y comentarios, con el nombre que aparece en el comentario.</p>
        <p>Tickets de soporte: tema, mensaje, correo y el estado del ticket.</p>
        <p>La fecha en la que se crea la cuenta y el último ingreso.</p>
      </Block>
      <Block title="Para qué los usamos">
        <p>Para abrir la sesión, mostrar tus guardados y comentarios, atender un ticket y enviarte el correo para cambiar la contraseña cuando lo pides.</p>
        <p>No vendemos estos datos. No los usamos para cobrar dentro de la aplicación.</p>
      </Block>
      <Block title="Cuánto tiempo">
        <p>
          Conservamos la cuenta mientras siga activa. Si pides eliminarla, borramos el perfil, los guardados, los comentarios y los tickets asociados, salvo una obligación legal de conservarlos.
        </p>
      </Block>
      <Block title="Tus derechos">
        <p>
          Puedes pedir acceso, corrección o eliminación de tus datos desde Ayuda o por WhatsApp. También puedes cambiar la contraseña con el enlace que enviamos a tu correo.
        </p>
      </Block>
      <Block title="WhatsApp">
        <p>
          Si escribes al grupo o a soporte, WhatsApp trata ese mensaje con sus propias reglas. Esa conversación no queda almacenada como un comentario dentro de DeportivosPro.
        </p>
      </Block>
    </Shell>
  );
}
